import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core'
import styles from './assets/styles/thirdPart.styles'
import Popover from './Popover'
import useElementVisible from '../app/hooks/useElementVisible'
import usePopoverToggles from '../app/hooks/usePopoverToggles'
import { CaratteristichePageConfig } from '../configuration'
import SlideUpHOC from '../SlideUpHOC'
import BlockRevealImage from '../BlockRevealImage'
import OnViewPortObserver from '../OnViewPortObserver'

const useStyles = makeStyles(styles)

function ThirdPartition() {
    const classes = useStyles()
    const [elementsVisible, setElemVisible] = useElementVisible({
        image: false,
        p: false,
        h1: false
    })
    const [popoverOpen, openPopover, closePopover] = usePopoverToggles({ first: null })
    return (
        <div className={classes.root} >
            <OnViewPortObserver
                absolute
                y={CaratteristichePageConfig.thirdContainer.imageOffset}
                yMobile={CaratteristichePageConfig.thirdContainer.imageOffsetMobile}
                onEnterViewPort={() => setElemVisible('image')}
            />
            <BlockRevealImage
                blockRevealClass={classes.imgWrap}
                imageSrc={CaratteristichePageConfig.thirdContainer.image}
                imgAlt='pavimento'
                hasOtherElements
                imageClass={classes.img}
                isInView={elementsVisible.image}
                addShadowOnVisible
                // popovers={
                //     <>
                //         <Popover
                //             x='60%'
                //             y='50%'
                //             name='first'
                //             anchorEl={popoverOpen.first}
                //             open={Boolean(popoverOpen.first)}
                //             handleClose={closePopover}
                //             handleOpen={openPopover}
                //             primaryDimension='15x90 cm'
                //             secondaryDimension='38"x228" R'
                //             color='Tobacco'
                //             decoro='chalet'
                //         />
                //     </>
                // }
            />
            <span className={classes.textWrap}>
                <SlideUpHOC duration='0.8s' when={elementsVisible.h1} >
                    <h1 className={classes.h1} >{CaratteristichePageConfig.thirdContainer.content.primary}</h1>
                </SlideUpHOC>
                <OnViewPortObserver
                    absolute
                    y={CaratteristichePageConfig.thirdContainer.primaryTextOffset}
                    yMobile={CaratteristichePageConfig.thirdContainer.primaryTextOffsetMobile}
                    onEnterViewPort={() => setElemVisible('h1')}
                />
                <SlideUpHOC duration='0.8s' when={elementsVisible.p} >
                    <p className={classes.p} >
                        {CaratteristichePageConfig.thirdContainer.content.secondary[0]}
                        <strong className="strong">{CaratteristichePageConfig.thirdContainer.content.secondary[1]}</strong>
                        {CaratteristichePageConfig.thirdContainer.content.secondary[2]}
                        <strong className="strong">{CaratteristichePageConfig.thirdContainer.content.secondary[3]}</strong>
                        {CaratteristichePageConfig.thirdContainer.content.secondary[4]}
                    </p>
                </SlideUpHOC>
                <SlideUpHOC rootClass={classes.rootClass} duration='0.8s' when={elementsVisible.p} >
                        <p className={classes.p} >
                            {CaratteristichePageConfig.thirdContainer.content.tertiary[0]}
                            <strong className="strong">{CaratteristichePageConfig.thirdContainer.content.tertiary[1]}</strong>
                            {CaratteristichePageConfig.thirdContainer.content.tertiary[2]}
                        </p>
                    </SlideUpHOC>
                <OnViewPortObserver
                    absolute
                    y={CaratteristichePageConfig.thirdContainer.subTextOffset}
                    yMobile={CaratteristichePageConfig.thirdContainer.subTextOffsetMobile}
                    onEnterViewPort={() => setElemVisible('p')}
                />
            </span>
        </div>
    )
}

export default memo(ThirdPartition)